module.exports = __webpack_public_path__ + "images/rich_heading/other/alcohol/icon_7f73f631f2f5ef2f2704260f65efa65a.png";